import { Box, Flex, Grid, Heading, Text } from "@radix-ui/themes";
import { HeroStyle2 } from "~/components/HeroStyle2";
import { HomeConsultForm } from "~/components/home/HomeConsultForm";
import {
	Locale,
	useLocalization,
} from "~/components/localization/LocalizationProvider";
import { OptimizedImage } from "~/components/OptimizedImage";
import styles from "../live-seo-page.module.css";

type Testimonial = {
	paragraphs: string[];
	author: string;
};

type TestimonialsLocalization = {
	title: string;
	sectionTitle: string;
	intro: string;
	testimonials: Testimonial[];
};

const testimonialsLocalization = {
	[Locale.EN]: {
		title: "Testimonials",
		sectionTitle: "Don't Take Our Word for It",
		intro:
			"Dr. Garcia-Paul loves creating beautiful smiles while developing relationships with you and your family and watching smiles, attitudes and confidence transform.",
		testimonials: [
			{
				paragraphs: [
					"I am so happy my daughters’ dentist recommended Miami Orthodontic Specialists to us. Dr. Garcia-Paul is very caring and professional. For my older daughter who needed braces right away, she gave us a detailed treatment plan and ensured all our questions were answered fully.",
					"My younger daughter is being monitored by Garcia-Paul periodically for orthodontic issues but has yet to need treatment. I appreciate that Dr. Garcia-Paul has not rushed her into braces. This just exemplifies what type of a kind and caring person she is.",
					"Her entire staff is outstanding, friendly, and efficient. The office is always spotless, and we never have to wait. Thank you, Dr. Garcia-Paul! I now have two daughters who want to be orthodontists just like you when they grow up!",
				],
				author: "Mercy",
			},
			{
				paragraphs: [
					"As many of us I did orthodontic treatment when I was a teen but did not wear my retainers so my teeth moved ... although it was something that really bothered me I was worried about the financial cost because I knew I didn’t want to get braces again but did not think I could afford Invisalign.",
					"I went to a few different consultations but Quickly realized how important it was to do the treatment with a board-certified orthodontist. Long story short I met with Dr Garcia-Paul.... I started treatment and have been super happy since!",
					"They were able to accommodate my busy schedule and offer me a really flexible financial plan. Highly recommend this office!!!!",
				],
				author: "Amanda",
			},
			{
				paragraphs: [
					"Dr. Carmen Garcia-Paul is extraordinary! She takes her time with patients providing individualized and detailed care. My daughter and niece love her!",
					"Her office is clean and organized. The staff are kind and professional. They have even accommodated our schedules to address things that require immediate attention. The girls’ smiles have improved tremendously since our first appointment.",
					"We are so happy we found Dr. Carmen Garcia-Paul. Her passion and dedication shows at every visit.",
				],
				author: "Thomas",
			},
			{
				paragraphs: [
					"We love Miami Orthodontic Specialists, Dr Garcia is wonderful and all her staff. My daughter has been in braces for about 1.5 years and all we had is a great experience.",
					"I’m a hygienist for over 20 years now and I highly recommend this office, not only to my patients but to all my friends and family.",
				],
				author: "Aman",
			},
			{
				paragraphs: [
					"Dr. Garcia-Paul and her staff are always prepared and ready for you. Also, her office is beautiful, clean and organized which makes it a nice place to come to and makes you feel welcome and special!",
					"They take the time to explain what will take place in each visit. The attention to detail and professionalism makes me feel at peace, knowing I am in the right place. I can’t wait to see the final results of my new smile.",
				],
				author: "Natty",
			},
		],
	},
	[Locale.ES]: {
		title: "Testimonios",
		sectionTitle: "No solo lo decimos nosotros",
		intro:
			"A la Dra. Garcia-Paul le encanta crear sonrisas hermosas mientras desarrolla relaciones contigo y tu familia, y ver cómo se transforman sonrisas, actitudes y confianza.",
		testimonials: [
			{
				paragraphs: [
					"Estoy muy feliz de que el dentista de mis hijas nos haya recomendado Miami Orthodontic Specialists. La Dra. Garcia-Paul es muy atenta y profesional. Para mi hija mayor, que necesitaba brackets de inmediato, nos dio un plan de tratamiento detallado y se aseguró de responder por completo todas nuestras preguntas.",
					"Mi hija menor está siendo monitoreada periódicamente por Garcia-Paul por temas de ortodoncia, pero todavía no ha necesitado tratamiento. Aprecio que la Dra. Garcia-Paul no la haya apresurado a usar brackets. Esto demuestra el tipo de persona amable y atenta que es.",
					"Todo su equipo es excelente, amable y eficiente. La oficina siempre está impecable y nunca tenemos que esperar. ¡Gracias, Dra. Garcia-Paul! Ahora tengo dos hijas que quieren ser ortodoncistas como usted cuando crezcan.",
				],
				author: "Mercy",
			},
			{
				paragraphs: [
					"Como muchos de nosotros, tuve tratamiento de ortodoncia cuando era adolescente, pero no usé mis retenedores, así que mis dientes se movieron... aunque era algo que realmente me molestaba, me preocupaba el costo porque sabía que no quería usar brackets de nuevo, pero no creía que pudiera pagar Invisalign.",
					"Fui a varias consultas, pero rápidamente me di cuenta de lo importante que era hacer el tratamiento con una ortodoncista certificada por la junta. En resumen, conocí a la Dra. Garcia-Paul... empecé el tratamiento y desde entonces he estado muy feliz.",
					"Pudieron adaptarse a mi agenda ocupada y ofrecerme un plan financiero muy flexible. ¡Recomiendo mucho esta oficina!",
				],
				author: "Amanda",
			},
			{
				paragraphs: [
					"¡La Dra. Carmen Garcia-Paul es extraordinaria! Se toma su tiempo con los pacientes y brinda una atención individualizada y detallada. ¡Mi hija y mi sobrina la adoran!",
					"Su oficina está limpia y organizada. El personal es amable y profesional. Incluso han acomodado nuestros horarios para atender cosas que requieren atención inmediata. Las sonrisas de las niñas han mejorado muchísimo desde nuestra primera cita.",
					"Estamos muy felices de haber encontrado a la Dra. Carmen Garcia-Paul. Su pasión y dedicación se notan en cada visita.",
				],
				author: "Thomas",
			},
			{
				paragraphs: [
					"Nos encanta Miami Orthodontic Specialists. La Dra. Garcia es maravillosa, al igual que todo su equipo. Mi hija ha usado brackets durante aproximadamente 1.5 años y todo lo que hemos tenido ha sido una gran experiencia.",
					"Soy higienista desde hace más de 20 años y recomiendo mucho esta oficina, no solo a mis pacientes, sino también a todos mis amigos y familiares.",
				],
				author: "Aman",
			},
			{
				paragraphs: [
					"La Dra. Garcia-Paul y su equipo siempre están preparados y listos para atenderte. Además, su oficina es hermosa, limpia y organizada, lo que la convierte en un lugar agradable para visitar y te hace sentir bienvenido y especial.",
					"Se toman el tiempo de explicar lo que ocurrirá en cada visita. La atención al detalle y el profesionalismo me dan tranquilidad, sabiendo que estoy en el lugar correcto. No puedo esperar a ver los resultados finales de mi nueva sonrisa.",
				],
				author: "Natty",
			},
		],
	},
} satisfies Record<Locale, TestimonialsLocalization>;

export function TestimonialsPage() {
	const getLocalization = useLocalization(testimonialsLocalization);
	const testimonials = getLocalization("testimonials");

	return (
		<Flex direction="column">
			<HeroStyle2
				heroImageUrl="/miami-ortho-11.jpg"
				title={getLocalization("title")}
				backgroundPosition="center"
			/>
			<Box className={styles.testimonialsIntroBand}>
				<Box className={styles.testimonialsInner}>
					<Heading as="h2" className={styles.testimonialsTitle}>
						{getLocalization("sectionTitle")}
					</Heading>
					<Text as="p" size="4" className={styles.testimonialsIntro}>
						{getLocalization("intro")}
					</Text>
				</Box>
			</Box>
			<Box className={styles.testimonialsBand}>
				<Box className={styles.testimonialsInner}>
					<Grid
						columns={{ initial: "1", sm: "2" }}
						gap="7"
						className={styles.testimonialGrid}
					>
						{testimonials.slice(0, 2).map((testimonial) => (
							<TestimonialBlock
								testimonial={testimonial}
								key={testimonial.author}
							/>
						))}
					</Grid>
					<OptimizedImage
						src="/miami-ortho-9.jpg"
						alt="Smiling boy with braces selecting colorful orthodontic rubber bands, assisted by a board-certified orthodontist in a modern Miami orthodontics office."
						className={styles.testimonialImage}
					/>
					<Grid
						columns={{ initial: "1", sm: "2" }}
						gap="7"
						className={styles.testimonialGrid}
					>
						{testimonials.slice(2).map((testimonial, index) => (
							<TestimonialBlock
								testimonial={testimonial}
								spanWide={index === testimonials.slice(2).length - 1}
								key={testimonial.author}
							/>
						))}
					</Grid>
				</Box>
			</Box>
			<Box className={styles.formWrap}>
				<HomeConsultForm />
			</Box>
		</Flex>
	);
}

function TestimonialBlock({
	testimonial,
	spanWide = false,
}: {
	testimonial: Testimonial;
	spanWide?: boolean;
}) {
	return (
		<blockquote
			className={
				spanWide
					? `${styles.testimonialBlock} ${styles.testimonialBlockWide}`
					: styles.testimonialBlock
			}
		>
			{testimonial.paragraphs.map((paragraph) => (
				<Text as="p" size="4" key={paragraph}>
					{paragraph}
				</Text>
			))}
			<Text as="p" size="4" className={styles.testimonialAuthor}>
				- {testimonial.author}
			</Text>
		</blockquote>
	);
}
